import { useState, useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Tooltip, tooltipClasses, Typography } from "@mui/material"
import { ButtonBasic, TableBase, TableLoadingComponent } from "../../components"
import ContactosService from "../../services/contactos.service";
import FechaFunction from "../../function/FechaFunction";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { styled } from '@mui/material/styles';
import { showModal } from "react-redux-modal-provider";
import ModalNewServicioSC from "../../modals/gobierno/ModalNewServicioSC";
import usePermisos from "../../hooks/usePermisos";

const DynamicTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.mode === 'dark' ? '#2d3a52' : theme.palette.common.white,
        color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'rgba(0, 0, 0, 0.87)',
        border: theme.palette.mode === 'dark' ? '1px solid #3d4a62' : 'none',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));
const PotencialesGobiernoScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const permisos = usePermisos()

    const actualizar = async () => {
        setLoading(true);
        await ContactosService.getAll({ type: 'gobierno' }).then((r)=>{
            setItems(r)
        }).finally(()=>setLoading(false));
    };
    const onClickNuevo = () => {
        navigate('/contactos/nuevogobierno');
    };
    const onClickSCNew = () => {
        showModal(ModalNewServicioSC)
    }
    const onOpenVer = (idCliente) => {
        const item = items.find((it)=> it.id_c === idCliente)
        if(item?.cuentaNubi_c){
            return navigate(`/contactos/${item?.cuentaNubi_c}/cuenta`,{state:{item:item}});
        }
        if(item?.nubicom){
            navigate(`/contactos/${item.id_c}/nubicom`,{state:{item:item}});
        }else if(item?.strong){
            navigate(`/contactos/${item.id_c}/strong`,{state:{item:item}});
        }else if(item?.ids){
            navigate(`/contactos/${item.id_c}/ids`,{state:{item:item}});
        }
        return ''
    }
    const columns = [
        {
            name: "id_c",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "createdAt",
            label: "Registrado",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return FechaFunction.format(value,'dd/MM/yyyy');
                }
            }
        },
        {
            label: "Nombre",
            name: "nombreCompleto_c",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'tipoDoc_c',
            label: "Tipo Documento",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(value === '96'){
                        return 'DNI';
                    }
                    if(value === '80'){
                        return 'CUIT';
                    }
                    return 'Sin Dato'
                }
            }
        },
        {
            label: 'DNI',
            name: 'documento_c',
        }
        ,{
            label: 'Correo',
            name: 'email_c',
        }
        ,{
            label: 'Categoria',
            name: 'categoria_cxe',
        }
        ,{
            label: 'Estado',
            name: 'estadoCliente_c',
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <DynamicTooltip  title="Perfil del Contacto" placement="top">
                                <IconButton color='primary' aria-label="ver" onClick={()=>onOpenVer(tableMeta.rowData[0])}>
                                    <AssignmentIndIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                                </IconButton>
                            </DynamicTooltip>
                        </Box>
                    </>
                )
            }
        }
    ];
    useEffect(() => {
        actualizar();
        document.title = `Potenciales Gobierno`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={4}>
                <Grid item xs={12} md={6} lg={6}>
                    <Typography variant="h2" sx={{color: isDarkMode ? '#e0e0e0' : '#111827', fontWeight: 'bold'}}>
                        Potenciales Clientes Gobierno/Eventuales
                    </Typography>
                </Grid>
                <Grid item xs={12} md={3} lg={3} sx={{display: 'flex', justifyContent: 'end'}}>
                    {permisos['trato.create.sc'] && (
                        <ButtonBasic
                            textButton="NUEVO SC"
                            sx={{width: 200, height: 30, color: '#fff',backgroundColor: '#01704a', '&:hover':{backgroundColor: '#02b879'}}}
                            onClick={()=>onClickSCNew()}
                            variant='wk'
                            color='nextStep'
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={3} lg={3} sx={{display: 'flex', justifyContent: 'center'}}>
                    {permisos['contactos.gobierno.created'] && (
                        <ButtonBasic
                            textButton="NUEVO"
                            sx={{width: 200, height: 30, color: '#fff'}}
                            onClick={()=>onClickNuevo('nubi')}
                            variant='wk'
                            color='nextStep'
                        />
                    )}
                </Grid>
                <Grid item xs={12} sx={{marginBottom: 15}}>
                    {loading ? (
                        <TableLoadingComponent />
                    ) : (
                        <TableBase title='Resultados' columns={columns} data={items} />
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default PotencialesGobiernoScreen